// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AttackOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AttackOffIcon" ref={forwardedRef} {...props}>
      <path d="M3.468 18.4h14.85v-3.217a3.2 3.2 0 0 0-.852-2.167c-.55-.601-1.225-1.003-2.056-1.113l1.779-2.616a1.64 1.64 0 0 0 .296-.938A1.64 1.64 0 0 0 17.19 7.41l-1.3-1.322-1.113 1.103.441.47c.5.533.573 1.008.326 1.365-.458.767-.936 1.563-1.34 2.236l-.003.004a309 309 0 0 0-.905 1.511c1.91 0 3.455 1.231 3.455 1.843v2.28H4.982z" />
      <path d="m1.78 18.4-.03-.03v.03z" />
      <path d="M1.75 15.88v-.697A3.2 3.2 0 0 1 2.624 13c.563-.602 1.16-.999 2.002-1.097L2.88 9.287A1.87 1.87 0 0 1 2.626 8.35 1.87 1.87 0 0 1 2.88 7.41l5.378-5.467A3.8 3.8 0 0 1 10.04 1.5a3.8 3.8 0 0 1 1.781.443l1.969 2.005L12.728 5a178 178 0 0 1-1.6-1.734c-.331-.366-1.885-.32-2.183 0A612 612 0 0 1 4.82 7.662C4.217 8.285 4.34 8.618 4.428 8.854l1.659 2.729-1.972 1.954a2.5 2.5 0 0 0-.615.61z" />
      <path d="m6.68 10.994-.037-.1a3.6 3.6 0 0 1-.212-1.261L6.43 6.249a22 22 0 0 1 5.277-.235l-1.39 1.377A13 13 0 0 0 7.91 7.563l.002 1.995a2 2 0 0 0 .008.21z" />
      <path d="M8.997 12.92a3 3 0 0 0 .379.03h1.259c.796-.002 1.559-.352 2.122-.974a3.5 3.5 0 0 0 .883-2.343V8.319L12.145 9.8a2.05 2.05 0 0 1-.506 1.138 1.7 1.7 0 0 1-1.221.573z" />
      <path d="M18.25 3.75 2.447 19.413l-1.065-1.056L17.185 2.695z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AttackOffIcon = /* @__PURE__ */ Object.assign(
  AttackOffIconComponent,
  { displayName: 'AttackOffIcon' },
);
